import { createStore } from "vuex";

export default createStore({
  state: {
    token: "",
    storeID: "",
    merchantID: "",
    phone: "",
  },
  getters: {
    getToken: (state) => state.token,
    getStoreID: (state) => state.storeID,
    getMerchantID: (state) => state.merchantID,
    getPhone: (state) => state.phone,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setStoreID(state, storeID) {
      state.storeID = storeID;
    },
    setMerchantID(state, merchantID) {
      state.merchantID = merchantID;
    },
    setPhone(state, phone) {
      state.phone = phone;
    },
  },
  actions: {},
  modules: {},
});
